import React, { useEffect } from 'react';

const ManageUsers = ({ handleShowHeader, handleShowSettingsHeader }) => {
    useEffect(() => {
        handleShowHeader(false);
        handleShowSettingsHeader(true);
    }, [handleShowHeader, handleShowSettingsHeader]);

    return (
        <div></div>
    );
};

export default ManageUsers;
